import { Menu } from '@zlib/data-access/models/menu.model';
import { v4 as uuidv4 } from 'uuid';

export class MenuConstants {
    static get ITEMS(): Menu[] {
        return [
            {
                id: uuidv4(),
                icon: 'ng-zorro:overview',
                title: 'menu.overview',
                url: '/dashboard'
            },
            {
                id: uuidv4(),
                icon: 'inbox',
                title: 'menu.invoice.overview',
                permisisons: [],
                children: [
                    {
                        id: uuidv4(),
                        icon: 'inbox',
                        title: 'menu.invoice.purchase',
                        url: `/invoice/purchase`
                    },
                    {
                        id: uuidv4(),
                        icon: 'inbox',
                        title: 'menu.invoice.sold',
                        url: `/invoice/sold`
                    },
                    {
                        id: uuidv4(),
                        icon: 'file-text',
                        title: 'menu.invoice.history',
                        permisisons: [],
                        url: `/invoice/histories`
                    },
                ]
            },
            {
                id: uuidv4(),
                icon: 'tool',
                title: 'menu.tool.xml',
                url: `/invoice/xml`,
                permisisons: [],
            },
            {
                id: uuidv4(),
                icon: 'inbox',
                title: 'menu.liability.overview',
                url: `/liability/`,
                permisisons: [],
            },
            {
                id: uuidv4(),
                icon: 'cluster',
                title: 'menu.enterprise.overview',
                permisisons: [],
                url: `/enterprise`
            },
            {
                id: uuidv4(),
                icon: 'cluster',
                title: 'menu.enterprise.blacklist',
                permisisons: [],
                url: `/enterprise/blacklist`
            }
        ];
    }
}
